import { Module } from 'vuex';

import { RootState } from 'frontend/types';

interface NuxSignupPage {
  page_header: string;
  is_marketing_diagnostic: boolean;
}

const INITIAL_STATE: NuxSignupPage = {
  page_header: '',
  is_marketing_diagnostic: false,
};

const nuxSignupPage: Module<NuxSignupPage, RootState> = {
  namespaced: true,
  state: INITIAL_STATE,
  getters: {
    pageHeader: (state: NuxSignupPage): string => state.page_header,
    isMarketingDiagnostic: (state: NuxSignupPage): boolean => state.is_marketing_diagnostic,
  },
  mutations: {
    setValue(state: NuxSignupPage, value: NuxSignupPage): void {
      Object.assign(state, value);
    },
  },
};

export default nuxSignupPage;
